<div class="box card-box shadow">
  <div class="box-header">
    <h3>{{ 'EMPLOYEE_HIRE.options_to_copy' | translate }}</h3>
  </div>

  <div class="box-body">
    <form [formGroup]="optionToCopyForm">
      <div class="row" test-id="ng-select">
        <div [ngClass]="contracts ? 'col-md-6' : 'col-md-12'">
          <div class="form-group">
            <label>
              {{ 'EMPLOYEE_HIRE.option' | translate }}
              <em class="fa fa-light fa-info-circle" *ngIf="!contracts"
                  tooltip="{{ 'EMPLOYEE_HIRE.option_tooltip' | translate}}"></em>
            </label>
            <ng-select class="form-control"
                       [readOnly]="!cliRegId"
                       [items]="optionsForCopy.items"
                       [(ngModel)]="optionsForCopy.selectedCopyInfoOption"
                       formControlName="selectedCopyInfoOption"
                       idField="value"
                       textField="display">
            </ng-select>
          </div>
        </div>
        <div class="col-md-6" *ngIf="contracts">
          <div class="form-group">
            <label>
              {{ 'EMPLOYEE_HIRE.source_contract' | translate }}
              <span class="required" *ngIf="optionsForCopy.selectedCopyInfoOption">*</span>
            </label>
            <gp-dropdown-select buttonClasses="btn-sm"
                                class="form-control"
                                [(ngModel)]="optionsForCopy.selectedContract"
                                formControlName="selectedContract"
                                [customPlaceholderGenerator]="customPlaceholderGenerator">
              <gp-dropdown-option *ngFor="let contract of contracts"
                                  [ngValue]="contract"
                                  [class.non-active]="!isInactiveContract(contract.enddate)">
                <img class="flag-icon"
                     *ngIf="contract.flag"
                     [attr.src]="contract.flag.href"/>
                {{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: contract.cliRegNickName} }}
                {{ getContractDate(contract) }}
              </gp-dropdown-option>
            </gp-dropdown-select>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
